module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#textsms",
      toString: function () {
        return this.url;
      }
    }